import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import axios from 'axios'; 
import { toast } from 'react-toastify';

const UploadWithImagePreviewList = ({ onFileUploadSuccess }) => {
    const [fileNames, setFileNames] = useState([]);
    const [error, setError] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const ALLOWED_TYPES = [
        'image/*',
        'video/*',
        'application/pdf',
        'application/msword',
        'video/webm',
        //'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        //'application/vnd.ms-excel',
        //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];

    const isValidFileType = (file) => {
        return ALLOWED_TYPES.some((type) => file.type.match(type));
    };
    const uploadFileToAWS = async (file) => {
        if (!file) {
          toast.error("Please select a file to upload.");
          return;
        }
      
        try {
          const formData = new FormData();
          formData.append("image", file);         
          formData.append("uploadPath", "Complaint");    // fixed value
          formData.append("fileName", file.name);      // filename again
          formData.append("sizes", "large");           // fixed size
          const response = await axios.post(`${API_BASE_URL}/backend/upload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${API_TOKEN}`,
            },
          });
      
          //const uploadData = response.data?.uploadResponses?.[0]?.data?.[0];
          //const uploadedUrl = uploadData?.availableSizes?.large;
          let uploadedUrl;

          // Check for image response structure
          if (response.data?.uploadResponses?.[0]?.data?.[0]?.availableSizes?.large) {
            uploadedUrl = response.data.uploadResponses[0].data[0].availableSizes.large;
          }
          // Check for video response structure
          else if (response.data?.data?.[0]?.url) {
            uploadedUrl = response.data.data[0].url;
          }
    


          if (uploadedUrl) {
            toast.success("File uploaded successfully!");
            if (onFileUploadSuccess) {
              onFileUploadSuccess(uploadedUrl); // Send to parent ✅
            }
            return uploadedUrl;
          } else {
            toast.error("File upload failed. No URL found.");
            return null;
          }
        } catch (error) {
          toast.error("Error uploading file.");
          console.error("AWS Upload Error:", error);
          return null;
        }
      };
      

      const handleFileChange = async (event) => {
        setError(null);
  const files = Array.from(event.target.files);
  const validFileNames = [];


        for (const file of files) {
            if (file.size > MAX_FILE_SIZE) {
                setError(`"${file.name}" exceeds 5MB file size limit.`);
                return;
            }
            if (!isValidFileType(file)) {
                setError(`"${file.name}" is not a supported file type.`);
                return;
            }
            const uploadedUrl = await uploadFileToAWS(file);
      if (uploadedUrl) {
        validFileNames.push(file.name); // Store only the file name for display
      }

        };

        if (validFileNames.length > 0) {
            setFileNames((prev) => [...prev, ...validFileNames]);
          }
      
    };

    const removeFileName = (name) => {
        setFileNames((prev) => prev.filter((fileName) => fileName !== name));
    };
    
    return (
        <div className="upload-container border border-neutral-300 rounded-lg p-4 bg-white">
            <div className="upload-label">
                <label
                    htmlFor="file-upload-name"
                    className="upload-button d-flex align-items-center justify-content-center gap-2 p-3 border border-dashed border-neutral-400 rounded-lg bg-neutral-100 hover:bg-neutral-200 cursor-pointer"
                >
                    <Icon icon="solar:upload-linear" className="text-xl text-neutral-600" />
                    <span className="text-neutral-700 font-medium">Click to upload</span>
                    <input
                        type="file"
                        className="form-control"
                        id="file-upload-name"
                        multiple
                        hidden
                        onChange={handleFileChange}
                        accept="image/*, video/*, .pdf, .doc, .docx"
                    />
                </label>
            </div>

            {error && (
                <div className="error-message text-danger fw-semibold mt-3">
                    {error}
                </div>
            )}

            {fileNames.length > 0 && (
                <div className="uploaded-files mt-4">
                    <ul className="list-unstyled">
                        {fileNames.map((fileName, index) => (
                            <li
                                key={index}
                                className="uploaded-file-item d-flex align-items-center justify-content-between p-2 border border-neutral-300 rounded-lg mb-2 bg-neutral-50"
                            >
                                <div className="d-flex align-items-center gap-2">
                                    <Icon
                                        icon="ph:link-break-light"
                                        className="text-xl text-neutral-500"
                                    />
                                    <span className="text-neutral-700">{fileName}</span>
                                    
                                </div>
                                <Icon
                                    icon="radix-icons:cross-2"
                                    className="remove-icon text-xl text-neutral-500 hover:text-danger-600 cursor-pointer"
                                    onClick={() => removeFileName(fileName)}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UploadWithImagePreviewList;